/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect }  from 'react';
import { useDispatch, useSelector } from 'react-redux';
//const 
import { businessTypeOptions, businessTypes } from '../../payment_const';
// material
import { Form, Grid, GridSet, GridItem, Link, Group, Icon, 
    ToolTip, TextField, FileUploader, SingleSelectDropDown } 
from '@insticator/insticator-ui'; // iui-material

//styles
import styles from './wiretransfer_styles';
import injectSheet from 'react-jss';
import { validation } from '../../../../../../../utils/validation';
import { fetchWireTransferInformation } from '../../../../../../../state/thunks/account';

const formName = 'WIRETRANSFER'

/* ========== ~~~~~~~~~~ WIRE TRANSFER ~~~~~~~~~~ ========== */
const WireTransfer = injectSheet(styles)((props) => {
  const dispatch = useDispatch()
  const { payments } = useSelector(state => state.account)

  const { wireTransferUUID, details, setDetails, onFormChange, onFormFileUpload, onFormFileDiscard, editable, isSaveClicked } = props

  useEffect(() => {
    if(wireTransferUUID) dispatch(fetchWireTransferInformation(wireTransferUUID))
  },[wireTransferUUID, dispatch])

  useEffect(() => {
    if(payments.wireTransfer && wireTransferUUID) setDetails(payments.wireTransfer)
  }, [payments, wireTransferUUID, setDetails])

  const isValid = name => !wireTransferUUID ? (!isSaveClicked || validation[name].test.test(details[name])) : !editable || validation[name].test.test(details[name])

  const uploadFile = file => onFormFileUpload(file)

  const discardFile = () => onFormFileDiscard()

  const isInternationCorporation = details.businessType === 'INTERNATIONAL_CORPORATION'

  const linkToForm = () => {
    if(details.w8BENEFormLink || details.w8BENFormLink) {
      if(isInternationCorporation) return details.w8BENEFormLink
      else return details.w8BENFormLink
    } else {
      return isInternationCorporation ?  `https://www.irs.gov/pub/irs-pdf/fw8bene.pdf` : `https://www.irs.gov/pub/irs-pdf/fw8ben.pdf`
    }
  }

  const downloadLink = () => `Download ${details.w8BENEFormLink || details.w8BENFormLink ? 'your' : ''} ${isInternationCorporation ? `W-8BEN-E Form` : `W-8BEN Form`}`

  const selectedForm = isInternationCorporation ? 'w8BENEForm' : 'w8BENForm'

  return(
    <Form formName={formName} >
      <Grid klass={`wiretransfer ${props.classes.wiretransfer}`}>
        <GridSet align={`horizontal`}>
            <GridItem type={`full`}>
            <label className={'label'}>Business Type</label>
              <SingleSelectDropDown 
                name={details.businessType ? businessTypes[details.businessType] : 'Select business type'} 
                searchable={false} 
                onSelect={opt => {
                  if(opt.value !== details.businessType) {
                    setDetails({
                      ...details,
                      businessType: opt.value,
                      w8Form: null,
                      w8BENFormLink: null,
                      w8BENFormName: '',
                      w8BENFormUpdateDateTime: '',
                      w8BENEFormLink: null,
                      w8BENEFormName: '',
                      w8BENEFormUpdateDateTime: ''
                    })
                  }
                }} 
                items={businessTypeOptions}
                valid={!wireTransferUUID ? (!isSaveClicked || !!details.businessType) : !editable || !!details.businessType}
                disabled={!editable}
              />
            </GridItem>
        </GridSet>
        <GridSet align={`horizontal`}>
            <GridItem>
                  <TextField 
                    type={`text`} name={`bankName`} value={details.bankName} valid={isValid('bankName')} formName={formName} 
                    placeholder={`Bank name`} label={`Bank Name`} info={``} required 
                    handleChange={e => onFormChange('bankName', e.target.value)} 
                    disabled={!editable}
                  />
            </GridItem>
            <GridItem>
                <TextField 
                  type={`text`} name={`accountName`} value={details.accountName} valid={isValid('accountName')} formName={formName} 
                  placeholder={`Account name`} label={`Account Name`} info={``} required 
                  handleChange={e => onFormChange('accountName', e.target.value)} 
                  disabled={!editable}
                />
            </GridItem>
        </GridSet>
        <GridSet align={`horizontal`}>
            <GridItem type={`full`}>
                <TextField 
                  type={`text`} name={`bankStreetAddress`} value={details.bankStreetAddress} valid={isValid('bankStreetAddress')} formName={formName} 
                  placeholder={`Street address`} label={`Bank Street Address`} info={``} required 
                  handleChange={e => onFormChange('bankStreetAddress', e.target.value)} 
                  disabled={!editable}
                />
            </GridItem>
        </GridSet>
        <GridSet align={`horizontal`}>
            <GridItem>
                <TextField 
                  type={`text`} name={`bankCity`} value={details.bankCity} valid={isValid('bankCity')} formName={formName} 
                  placeholder={`City`} label={`Bank City`} info={``} required 
                  handleChange={e => onFormChange('bankCity', e.target.value)} 
                  disabled={!editable}
                />
            </GridItem>
            <GridItem>
                <TextField 
                  type={`text`} name={`bankRegion`} value={details.bankRegion} valid={isValid('bankRegion')} formName={formName} 
                  placeholder={`State`} label={`Bank State / Province`} info={``} required 
                  handleChange={e => onFormChange('bankRegion', e.target.value)} 
                  disabled={!editable}
                />
            </GridItem>
        </GridSet>
        <GridSet align={`horizontal`}>
            <GridItem>
                <TextField 
                  type={`text`} name={`bankZipCode`} value={details.bankZipCode} valid={isValid('bankZipCode')} formName={formName} 
                  placeholder={`Zip/Postal code`} label={`Bank Zip Code`} info={``} required 
                  handleChange={e => onFormChange('bankZipCode', e.target.value)} 
                  disabled={!editable}
                />
            </GridItem>
            <GridItem>
                <TextField 
                  type={`text`} name={`bankCountry`} value={details.bankCountry} valid={isValid('bankCountry')} formName={formName} 
                  placeholder={`Bank Country`} label={`Bank Country`} info={``} required
                  handleChange={e => onFormChange('bankCountry', e.target.value)} 
                  disabled={!editable}
                />
            </GridItem>
        </GridSet>
        <GridSet align={`horizontal`}>
            <GridItem>
                <TextField 
                  type={`text`} name={`swift`} value={details.swift} valid={isValid('swift')} formName={formName} 
                  placeholder={`SWIFT bank code`} label={`Swift`} info={``} required 
                  handleChange={e => onFormChange('swift', e.target.value)} 
                  disabled={!editable}
                />
            </GridItem>
            <GridItem>
                <TextField 
                  type={`text`} name={`iban`} value={details.iban} valid={isValid('iban')} formName={formName} 
                  placeholder={`Account number / IBAN`} label={`Account number / IBAN`} info={``} required 
                  handleChange={e => onFormChange('iban', e.target.value)} 
                  disabled={!editable}
                />
            </GridItem>
        </GridSet>
        <GridSet align={`horizontal`}>
          <GridItem>
              <Group name={`upload-form valid-true`} >
                  <span>
                    {isInternationCorporation ? `W-8BEN-E Form` : `W-8BEN Form`} <ToolTip align={`right`} action={`click`} 
                              content={<p>Please make sure you are uploading a file in PDF format (we currently do not support other file formats).</p>}>
                                <Icon name={`exclamation-circle`} />
                            </ToolTip>
                  </span>
                  <FileUploader disabled={!editable} uploadFile={uploadFile} discardFile={discardFile} 
                    maxSize={5000} supportedFileTypes={['application/pdf']} 
                    filePreviewText={details[`${selectedForm}UpdateDateTime`]}
                    fileName={details[`${selectedForm}Name`]}
                    isValid={!wireTransferUUID ? (!isSaveClicked || !!(details[`${selectedForm}Name`] || details['w8Form'])) : !editable || !!(details[`${selectedForm}Name`] || details['w8Form'])}
                  />
                  <Link name={'w9formlink'} text={downloadLink()} 
                    variant={`primary`} type={`external`} action={linkToForm()} 
                    icon={`arrow-down`} iconRight disabled={!editable}
                  />
              </Group>
            </GridItem>
        </GridSet>
    </Grid>
    </Form>
  );

})



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default WireTransfer
